

const HorizontalScroller = function (element, slideChangeCB, calcHeight=true) {
    const slideshow = this
    slideshow.element = element
    slideshow.slides = slideshow.element.querySelectorAll(".keyhole img, .keyhole article, .keyhole .slide")
    slideshow.keyhole = slideshow.element.querySelector(".keyhole")
    slideshow.strip = slideshow.element.querySelector(".strip")
    slideshow.numberOfSlides = slideshow.slides.length
    slideshow.currentSlideNum = 1
    slideshow.slideChangeCB = slideChangeCB

    slideshow.init = function(){

        let slideHeight = slideshow.findTallestSlide();

        // only activate the slider if we have more than one slide. 
        if(slideshow.slides.length>0)
        {
            // we should modify the width of the slidestrip
            // step 1, get slideshow keyhole size...
            slideshow.strip.style.width =  (slideshow.keyhole.clientWidth * slideshow.numberOfSlides) + "px"     
            
            slideshow.slides.forEach(slide => {
                slide.style.width = slideshow.keyhole.clientWidth + "px";
                if(calcHeight){
                    slide.style.height = slideHeight + "px";
                }
                
            })

                
        }
    }

    slideshow.findTallestSlide = function(){
        let maxHeight = 0;
        slideshow.slides.forEach(slide => {
            console.log(slide);
            maxHeight = Math.max(maxHeight, slide.clientHeight);
        })

        return maxHeight;
    }

    slideshow.nextSlide = function(){
        if(slideshow.currentSlideNum != slideshow.numberOfSlides)
        {
            slideshow.currentSlideNum++
            slideshow.strip.style.left = -1*(slideshow.keyhole.clientWidth*(slideshow.currentSlideNum-1)) + "px";
        } else {
            slideshow.strip.style.left = -1*(slideshow.keyhole.clientWidth*(slideshow.currentSlideNum-1))-20 + "px";
            setTimeout(function(){
                slideshow.strip.style.left = -1*(slideshow.keyhole.clientWidth*(slideshow.currentSlideNum-1)) + "px";
            }, 200)
        }
    }

    slideshow.prevSlide = function(){
        if(slideshow.currentSlideNum != 1)
        {
            slideshow.currentSlideNum = slideshow.currentSlideNum -1;
            slideshow.strip.style.left = -1*(slideshow.keyhole.clientWidth*(slideshow.currentSlideNum-1)) + "px";
        } else {
            slideshow.strip.style.left = -1*(slideshow.keyhole.clientWidth*(slideshow.currentSlideNum-1))+20 + "px";
            setTimeout(function(){
                slideshow.strip.style.left = -1*(slideshow.keyhole.clientWidth*(slideshow.currentSlideNum-1)) + "px";
            }, 200)
        }
    }

    slideshow.init();
};

export default HorizontalScroller;
